import { DeleteOutlined } from '@icon';
import { Button } from '@ui';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import TStore from '../../../types/store';
import CalendarDayView from '../components/calendar-day-view';
import { CancelVisitModal } from '../components/calendar-view/components/cancel-visit-modal/cancel-visit-modal';
import ReservationForm from '../components/reservation-form/reservation-form';
import { EVisitsEditSC } from './e-visits-edit.styled';

type EVisitsEditProps = {};

const EVisitsEdit: React.FunctionComponent<EVisitsEditProps> = ({}) => {
  const [deleteModalVisible, setDeleteModalVisible] = useState<boolean>(false);
  const { push, goBack } = useHistory();

  const { orderId, visitItem } = useSelector((state: TStore) => ({
    orderId: state.reservationForm.visitItem.order?.id,
    visitItem: state.reservationForm.visitItem,
  }));

  const pageRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!orderId) {
      push(`/e-visits/calendar`);
    } else if (pageRef.current) {
      pageRef.current?.scrollTo({ top: 0 });
    }
  }, [orderId, pageRef]);

  return (
    <EVisitsEditSC
      ref={pageRef}
      onBack={goBack}
      extra={
        <Button
          size="medium"
          Icon={DeleteOutlined}
          variant="danger"
          onClick={() => setDeleteModalVisible(true)}
        >
          Zrušiť termín
        </Button>
      }
    >
      <div className={'e-visit-content'}>
        <div className={'modal-container'}>
          {orderId ? (
            <ReservationForm
              mode={'edit'}
              onClose={() => push(`/e-visits/calendar`)}
              handleDeleteClick={() => setDeleteModalVisible(true)}
              placement="page"
            />
          ) : null}
        </div>
        <CalendarDayView />
        <CancelVisitModal
          visible={deleteModalVisible}
          onClose={() => {
            setDeleteModalVisible(false);
          }}
          event={visitItem}
          onSuccess={() => {
            push(`/e-visits/calendar`);
          }}
        />
      </div>
    </EVisitsEditSC>
  );
};

export default React.memo(EVisitsEdit);
